// @ts-ignore
if (!window.requestPostAnimationFrame) {
  // @ts-ignore
  window.requestPostAnimationFrame = function(task) {
    requestAnimationFrame(() => {
      setTimeout(task, 0);
    });
  };
}
// https://github.com/WICG/requestPostAnimationFrame/blob/master/explainer.md
// https://developer.mozilla.org/en-US/docs/Web/API/WebGL_API/WebGL_best_practices

import "./index.css";

import { mat4 } from "gl-matrix";
import TWEEN from "@tweenjs/tween.js";
import { fromEvent } from "rxjs";
import { filter, map } from "rxjs/operators";

import Router from "./router";
import { GameState } from "./interfaces";
import { deg2rad, dimensionsMaintainingAspectWithMax } from "./helpers/math-helpers";
import { enableVertexAttribArray0 } from "./helpers/webgl-helpers";
import Camera from "./camera";

export const MAX_DIMENSION = 640;

const gameCanvas: HTMLCanvasElement = <HTMLCanvasElement>document.getElementById("game");
const gameGl = gameCanvas.getContext("webgl", { alpha: false });

const projectionMatrix = mat4.create();
const modelMatrix = mat4.create();
const viewMatrix = mat4.create();
const viewProjectionMatrix = mat4.create();
const inverseViewProjectionMatrix = mat4.create();
let aspect = getAspectRatio(gameGl.canvas);

// Deal with havign to hardcode Itch's CDN
const url = window.location.href.replace("index.html", "");
const ITCH_CDN = "hwcdn.net";
const itchCdnPath = !!url.match(ITCH_CDN) ? url : null;

const resize$ = fromEvent(window, "resize");
const domLoaded$ = fromEvent(document, "DOMContentLoaded");

export const state: GameState = {
  o$: { resize$ },
  paused: false,
  canvasDimensions: [-1, -1],
  numTiles: -1,
  happenedEvents: {},
  aspect,
  router: null,
  currentPlayer: null,
  get moveable() {
    return !this.inCinematic && !document.querySelector(".js-dialogue");
  },
  inCinematic: false,
  itchCdnPath,
  playerPath: [],
  programWrappers: {},
  viz: {
    camera: new Camera(),
    zNear: 0.1,
    zFar: 100.0,
    fieldOfView: deg2rad(45),
    up: [0, 1, 0],
    inverseViewProjectionMatrix,
    modelMatrix,
    projectionMatrix,
    viewMatrix,
    viewProjectionMatrix
  }
};

// Configure router
const router = new Router();
state.router = router;
router.startRouter();

const otherKeys = ["p"];
const keyDown$ = fromEvent(document, "keydown");
resize();
resize$.subscribe(resize);

domLoaded$.subscribe(resize);

enableVertexAttribArray0(gameGl);

function resize() {
  aspect = getAspectRatio(gameCanvas);
  state.aspect = aspect;
  const dimensions = dimensionsMaintainingAspectWithMax(
    MAX_DIMENSION,
    aspect,
    window.innerWidth,
    window.innerHeight
  );

  const width = dimensions[0];
  const height = dimensions[1];

  state.canvasDimensions[0] = width;
  state.canvasDimensions[1] = height;
  gameCanvas.width = width;
  gameCanvas.height = height;
  gameGl.viewport(0, 0, width, height);
}

function tick(timestamp) {
  TWEEN.update(timestamp);
  requestAnimationFrame(tick);

  if (router.loadingPage && router.loadingPage.loaded) {
    router.loadingPage.tick(timestamp);
  } else if (router.currentRoute && router.currentRoute.loaded) {
    router.currentRoute.tick(timestamp);
  }
}

const otherKeyDown$ = keyDown$.pipe(
  filter((e: KeyboardEvent) => otherKeys.includes(e.key)),
  map(e => e.key)
);

otherKeyDown$.subscribe(() => (state.paused = !state.paused));

function getAspectRatio(canvas) {
  return canvas.clientWidth / canvas.clientHeight;
}

// @ts-ignore
requestPostAnimationFrame(tick);
